import { AuthErrorCode, LoginErrorCode } from './errorCodes';

export const LOGIN_ERROR_MESSAGES: Record<LoginErrorCode, string> = {
  [LoginErrorCode.EMPTY_USERNAME]: 'Please fill in all required fields.',
  [LoginErrorCode.EMPTY_PASSWORD]: 'Please fill in all required fields.',
  [LoginErrorCode.INVALID_USERNAME]: 'Invalid email address.',
  [LoginErrorCode.INVALID_EMAIL]: 'Invalid email address.',
  [LoginErrorCode.INCORRECT_PASSWORD]: 'Incorrect password.',
  [LoginErrorCode.AUTHENTICATION_FAILED]: 'Login failed. Please check your credentials.',
};

export const AUTH_ERROR_MESSAGES: Partial<Record<AuthErrorCode, string>> = {
  // Common - Missing Fields
  [AuthErrorCode.MISSING_PHONE]: 'Please enter your phone number.',
  [AuthErrorCode.MISSING_OTP]: 'Please enter your verification code.',
  [AuthErrorCode.MISSING_NAME]: 'Please enter your name.',
  [AuthErrorCode.MISSING_EMAIL]: 'Please enter your email address.',

  // Common - Format Errors
  [AuthErrorCode.INVALID_PHONE_FORMAT]: 'Please enter a valid phone number.',
  [AuthErrorCode.INVALID_EMAIL_FORMAT]: 'Please enter a valid email address.',
  [AuthErrorCode.INVALID_OTP]: 'Please enter a valid verification code.',

  // OTP
  [AuthErrorCode.OTP_EXPIRED]: 'Your code has expired. Please request a new one.',
  [AuthErrorCode.OTP_NOT_FOUND]: 'No verification code found. Please request a new one.',
  [AuthErrorCode.MAX_ATTEMPTS_EXCEEDED]: 'Too many attempts. Please try again later.',

  // Email Verification
  [AuthErrorCode.SESSION_NOT_FOUND]: 'Your session has expired. Please start over.',
  [AuthErrorCode.SESSION_LOCKED]: 'Your session has been locked. Please start over.',

  // Registration
  [AuthErrorCode.USER_ALREADY_EXISTS]: 'User with this phone number or email already exists.',
  [AuthErrorCode.CUSTOMER_CREATION_FAILED]: 'Failed to create customer account. Please try again.',

  // Google OAuth
  [AuthErrorCode.USER_NOT_FOUND]: 'No account found. Please complete registration.',
};
